(() => {
  const initGrowthEngine = () => {
    document.querySelectorAll('[data-nyum-growth-config]').forEach((config) => {
      if (config.dataset.nyumGrowthReady === 'true') return;
      config.dataset.nyumGrowthReady = 'true';
      const handle = config.dataset.handle;
      const root = document.querySelector(`[data-nyum-product-root][data-product-handle="${handle}"]`);
      if (!root) return;

      const subscription = root.querySelector('[data-nyum-subscription]');
      if (subscription && config.dataset.subscriptionReady === 'true') {
        subscription.querySelectorAll('.nyum-growth-sub-economics,.nyum-growth-sub-badges,.nyum-growth-protocol-cue').forEach((node) => node.remove());

        const supplies = root.querySelectorAll('.nyum-v2-supply');
        if (supplies.length === 1) root.classList.add('nyum-growth-single-choice');

        const oneTimeInput = subscription.querySelector('input[value="one-time"]');
        const subscribeInput = subscription.querySelector('input[value="subscribe"]');
        const oneTimeLabel = oneTimeInput?.closest('label');
        const subscribeLabel = subscribeInput?.closest('label');
        const oneTimeSmall = oneTimeLabel?.querySelector('small');
        const subscribeSmall = subscribeLabel?.querySelector('small');
        const oneTimeEm = oneTimeLabel?.querySelector('em');

        if (oneTimeSmall) oneTimeSmall.textContent = 'ONE-TIME PURCHASE';
        if (oneTimeEm) oneTimeEm.textContent = 'BUY ONCE';
        if (subscribeSmall) subscribeSmall.textContent = Number(config.dataset.subscriptionDiscount) > 0 ? `SUBSCRIBE & SAVE ${config.dataset.subscriptionDiscount}%` : 'SUBSCRIBE & SAVE';

        if (subscribeLabel && Number(config.dataset.subscriptionDiscount) > 0 && !subscribeLabel.querySelector('.nyum-growth-best-value')) {
          const badge = document.createElement('i');
          badge.className = 'nyum-growth-best-value';
          badge.textContent = 'BEST VALUE';
          subscribeLabel.append(badge);
        }

        const cadenceHeading = subscription.querySelector('.nyum-v2-subscription__plans > b');
        if (cadenceHeading) cadenceHeading.textContent = 'DELIVERY FREQUENCY';
      }

      const desk = document.querySelector(`[data-nyum-growth-desk][data-product-handle="${handle}"]`);
      if (desk && desk.dataset.nyumMoved !== 'true') {
        const target = handle === 'shilaforce' ? root.querySelector('.nyum-shila-faq') : root.querySelector('.nyum-v2-pdp-faq');
        if (target) target.before(desk); else root.append(desk);
        desk.dataset.nyumMoved = 'true';
      }
    });
  };

  initGrowthEngine();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGrowthEngine, { once: true });
  window.addEventListener('pageshow', initGrowthEngine);
  document.addEventListener('shopify:section:load', initGrowthEngine);
})();
